<template>
  <div class="static-info">
    <div>
        <el-checkbox label="Основная статистика комментов, лайков, репостов, просмотров и анализ вовлеченности" v-model="info.main_stats"></el-checkbox>
        <el-checkbox label="Анализ связей источников" v-model="info.links"></el-checkbox>
        <el-checkbox label="Активные подписчики" v-model="info.actives"></el-checkbox>
        <el-checkbox label="Статистика лояльности комментариев" v-model="info.comments_trust"></el-checkbox>
        <el-checkbox label="Статистика по городам" v-model="info.cities"></el-checkbox>
        <el-checkbox label="Сбор статистики по лайкам" v-model="info.likes"></el-checkbox>
        <el-checkbox label="Сбор статистики комментариев" v-model="info.comments"></el-checkbox>
        <el-checkbox label="Сбор статистики репостов" v-model="info.reposts"></el-checkbox>
        <el-checkbox label="Сбор охвата пользователей" v-model="info.attendance"></el-checkbox>
        <el-checkbox label="Формирование расширенной лояльности - локация, объект, субъект" v-model="info.extended_sentiment"></el-checkbox>
        <el-button type="primary" @click="setSettings()">Применить</el-button>
    </div>
  </div>
</template>

<script>
  // api
  import { getStatsParamsApi,setStatsParamsApi } from '../../../../../api/feeds';

  // vuex
  import { mapGetters } from "vuex";

  export default {
    name: 'Static',
    data() {
      return {
        info: {
          thread_id: 0,
          actives: true,
          cities: false,       
          comments_trust: true,
          links: true,
          main_stats: true,
          likes: false,
          comments: false,
          reposts: false,
          attendance: false,
          extended_sentiment: false
        },
      };
    },
    computed: {
      ...mapGetters([
        "users",
        "isAdmin",
      ]),
    },
    methods: {
      loadThreadExtended() {
        let params = {
          thread_id: parseInt(this.$route.params.threadId)
        };

        getStatsParamsApi(params).then((resp) => {
          this.info = resp.data;
        });
      },
      setSettings() {
        let params = this.info
        setStatsParamsApi(params).then((resp) => {
          this.info = resp.data;
        });
      }
    },
    mounted() {
      this.loadThreadExtended();
    },
  };
</script>

<style>
.static-info .el-checkbox{
  display: block;
  height: 50px;
}
</style>